import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-accommodation-confirmation",
  templateUrl: "./accommodation-confirmation.component.html",
  styleUrls: ["./accommodation-confirmation.component.scss"],
})
export class AccommodationConfirmationComponent implements OnInit {
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private activatedRoute: ActivatedRoute
  ) {}

  accommodation: any;
  accommodationreservation: any;

  loading = false;
  refreshing = true;
  notification = {};
  response = {};
  downloader: any = null;
  skeletonLoader = true;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.accommodation = authData("_accommodation");

    this.refreshing = true;

    const baseUrl = `${environment.BASE_URL}/accomodation/accomodationConfirmation`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.accommodationreservation = res.Data;
          this.skeletonLoader = false;
          this.refreshing = false;
        } else {
          this.notification = errorHandler(res);
          this.skeletonLoader = true;
          this.refreshing = true;
        }
      },
      error: (err: any) => {
        this.notification = errorHandler(err);
        this.skeletonLoader = true;
        this.refreshing = true;
      },
    });
  }

  downloadApplicationForm(): void {
    if (this.loading) return;

    this.loading = true;
    this.notification = {};
    this.downloader = { loading: true };

    this.httpClient.get(`${environment.BASE_URL}/accomodation/accommodationApplicationForm`, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.downloader = {
            loading: false,
            name: res.Data.Name,
            url: `data:application/octet-stream;base64,${res.Data.Data}`,
          };
        } else {
          this.downloader = null;
          this.notification = { error: true, message: res.Message };
          this.loading = false;
        }
      },
      error: (err: any) => {
        this.downloader = null;
        this.notification = errorHandler(err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  accommodationPaymentConfirmation() {
    this.loading = true;
    this.notification = {};

    this.downloader = {
      loading: true,
    };

    const baseUrl = `${environment.BASE_URL}/accomodation/accommodationPaymentConfirmation`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        if (res.Success) {
          this.downloader = {
            loading: false,
            name: res.Data.Name,
            url: `data:application/octet-stream;base64,${res.Data.Data}`,
          };
        } else {
          this.downloader = null;
          this.notification = { error: true, message: res.Message };
          this.loading = false;
        }
      },
      error: (err: any) => {
        this.downloader = null;
        this.notification = errorHandler(err);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }
}
